export default "__VITE_ASSET__Du$PJceE__"